import React,{useState, useEffect} from "react";
import { API } from '../../../services/api';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import ImgLoading from '../../../assets/cargacaleta.gif';
import "./UserProfile.scss";

export function UserProfilePage() {
  /**
   * Vista del perfil de usuario
   * Recibe por la url un query idUser
   * con esta propiedad se consultan los datos del usuario al servidor
   * y se los renderiza en un card
   */

  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }

  const approvedUser = async(userId)=>{
    if(window.confirm('Aprobar usuario?')){
      setLoading(true);
      /**
       * Se hace el llamado al servicio /users/update-user-approval-state
       */
      await API.putUserApprovalSatate({
        userId,
        approvalState: 'APPROVED'
      });
      /**
       * Se hace el llamado al servicio /users/get-user-by-id
       */
      await API.putUserById(userId)
      .then(x => {
        setUser(x);
      })
      setLoading(false);
    }
    
  }

  useEffect(()=>{
    protectedRoute();
    const queryParams = new URLSearchParams(location.search);
    setLoading(true);
    /**
     * Se hace el llamado al servicio /users/get-user-by-id
     */
    API.putUserById(queryParams.get('userId'))
    .then(x => {
      setUser(x);
      setLoading(false);
    })
    .catch(x => {
      setLoading(false);
    });
  },[])

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Datos Del Usuario</h2>
        <div className="card">
          <p>{user.approvalState}</p>
          <h1>{user.name} {user.lastname}</h1>
          <h3>RUT: {user.rut}</h3>
          <h3>{user.email}</h3>
          <h3>{user.phone}</h3>
          <br />
          <p>Fecha de registro: {new Date(user._createTimestamp).toLocaleDateString()}</p>
          <p>Mensaje: {user.message}</p>
          <p>Región: {user.regionKey}</p>
          <p>Ciudad: {user.cityKey}</p>
          <p>Comuna: {user.communeKey}</p>
          <p>Sector: {user.sectorKey}</p>

          <p>Foto de perfil</p>
          <img src={user.photoUrl ?? "https://www.tibs.org.tw/images/default.jpg"} 
          alt="Foto perfil"
          style={{height:150, borderRadius:10}} />
          <p>Foto de cover</p>
          <img src={user.coverUrl ??"https://www.tibs.org.tw/images/default.jpg"} 
          alt="Foto perfil"
          style={{height:220, borderRadius:10}} />
        </div>

        <button className="button-approved" onClick={()=> approvedUser(user._id)}>Aprobar</button>
        <Link className="button-reject" to={{
          pathname:`comment-reject-user`,
          search: `?userId=${user._id}`}}>Rechazar</Link>
      </main>
    </>
  )
}
